module.exports = __webpack_public_path__ + "img/a3.0b955e6c.svg";